<template>
  <div class="config-tag-container">
    <div class="config-toggle-section my-4">
      <mf-toggle v-model="useTag" class="pa-0" hide-details label="Tag na oferta" :disabled="finishedHighlight" />
    </div>
    <div v-if="useTag" class="select-tag-type-section">
      <v-radio-group v-model="selectedTagType" class="tag-group">
        <div class="default-tag">
          <div class="product-section" :class="isSelected('default') && 'use-border'">
            <product-card
              variant="basic-chip"
              product-image-src="highlight-products-images/product-beats-1.png"
              chip-label="Desconto"
              rule-chip-label="Máximo x por CPF *"
              discount-label="- 15%"
              :price="0"
              :discount-number="5"
              product-name="Produto exemplo 1"
              product-measure="Unidade"
              chip-color="#9D9D9D"
              discount-color="#D8D8D8"
              use-default-tag
            />
          </div>
          <div class="radio-section">
            <v-radio
              key="expanded"
              label="Estrela com a cor do app"
              color="primary"
              value="default"
              :class="isSelected('default') && 'use-weight'"
              :disabled="finishedHighlight"
            />
          </div>
        </div>
        <div class="image-tag">
          <div class="product-section" :class="isSelected('use-image') && 'use-border'">
            <product-card
              variant="basic-chip"
              product-image-src="highlight-products-images/product-beats-2.png"
              chip-label="Desconto"
              rule-chip-label="Máximo x por CPF *"
              discount-label="- 15%"
              :price="0"
              :discount-number="5"
              product-name="Produto exemplo 1"
              product-measure="Unidade"
              chip-color="#9D9D9D"
              discount-color="#D8D8D8"
            />
          </div>
          <div class="radio-section">
            <v-radio
              key="use-image"
              label="Imagem personalizada"
              color="primary"
              value="use-image"
              :class="isSelected('use-image') && 'use-weight'"
              :disabled="finishedHighlight"
            />
          </div>
        </div>
      </v-radio-group>
      <mf-image-cropper
        :mb-size-limit="0.5"
        :disabled="!isSelected('use-image') || finishedHighlight"
        :upload-image="modifyImg"
        :error-message="''"
        :url="imageURL"
        :width="100"
        :height="100"
        show-hint
        @remove-image="deleteFile"
        @snackbar="showSnackbar"
      />
    </div>
  </div>
</template>

<script>
import { MUTATION_SINGLE_UPLOAD_BASE64 } from '@/graphql'
import { highlightOffer } from '../../../../mixins/highlight-offer'
export default {
  name: 'ConfigTag',
  components: {
    ProductCard: () => import('../ProductCard.vue'),
  },
  mixins: [highlightOffer],
  data: () => ({
    imageUploaded: false,
  }),
  computed: {
    selectedTagType: {
      get() {
        return this.tagType
      },
      set(value) {
        this.setTagType(value)
      },
    },
    imageURL: {
      get() {
        return this.highlightTag.image
      },
      set(value) {
        this.setHighlightKeyValue({
          payload: {
            active: true,
            image: value,
          },
          key: 'tag',
        })
      },
    },
    useTag: {
      get() {
        return this.highlightTag.active
      },
      set(value) {
        this.selectedTagType = ''
        this.setHighlightKeyValue({
          payload: {
            active: value,
            image: '',
          },
          key: 'tag',
        })
      },
    },
    finishedHighlight() {
      return this.highlightStatus === 'FINISHED'
    },
  },
  watch: {
    selectedTagType: {
      handler(value) {
        if (value === 'default') {
          this.imageURL = ''
        }
      },
      deep: true,
    },
  },
  methods: {
    isSelected(type) {
      return this.selectedTagType === type
    },
    showSnackbar(snackbar) {
      this.$snackbar(snackbar)
    },
    deleteFile() {
      this.imageURL = ''
    },
    async modifyImg({ base64, filename }) {
      await this.$apollo
        .mutate({
          mutation: MUTATION_SINGLE_UPLOAD_BASE64,
          variables: {
            filename,
            base64,
          },
        })
        .then(({ data: { singleUploadBase64 } }) => {
          const { url } = singleUploadBase64
          this.imageUploaded = true
          this.imageURL = url
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.config-tag-container {
  .config-toggle-section {
    ::v-deep .v-label {
      color: $cinza-d10;
      font-family: Lato;
      font-size: 18px !important;
      font-style: normal;
      font-weight: 700 !important;
      line-height: 120%; /* 21.6px */
    }
  }
  .select-tag-type-section {
    display: flex;
    flex-direction: column;
    gap: 28px;
    .tag-group {
      display: flex;
      flex-direction: row;
      margin-top: 16px;
      .default-tag,
      .image-tag {
        display: flex;
        flex-direction: column;
        justify-content: center !important;
        align-items: center;
        gap: 16px;
      }
    }
  }
  .use-border {
    border: 2px solid $marca-0;
  }
  .use-weight {
    ::v-deep .v-label {
      font-weight: 700;
    }
  }

  .product-section {
    background-color: #f8f8f8;
    border-radius: 15px;
    width: 185px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 16px 16px 0px;
  }
}

::v-deep .v-input--radio-group--column .v-input--radio-group__input {
  width: 100%;
  display: flex !important;
  flex-direction: row !important;
  gap: 64px;
}
</style>
